<template>
  <my-modal
    v-model:visible="visibleModel"
    :title="title"
    @save="sendSms"
    save-text="Илгээх"
    :saving="loading"
    :readonly="!!item"
  >
    <my-input :readonly="!!item" v-model="phones" label="Илгээх дугаарууд" required :mask="maskPhones" placeholder="####-####, ####-####, ...">
      <div class="label-text text-right pt-2">{{ phoneCount }} / {{ 100 }}</div>
    </my-input>
    <my-input :readonly="!!item" v-model="text" type="textarea" label="Утга" required :maxlength="160"></my-input>
    <my-input v-if="item && item.customer" :readonly="!!item" :value="item.customer.firstName" label="Харилцагч"></my-input>
    <my-input v-if="item && item.contract" :readonly="!!item" :value="item.contract.regNo" label="Харилцагч"></my-input>
  </my-modal>
</template>
<script>
import { regexpMobile, regexpSmsText } from '../../utils/regexps'
export default {
  props: {
    id: { type: Number, default: null },
    visible: { type: Boolean, default: false },
    item: { type: Object }
  },
  data () {
    return {
      loading: false,
      phones: '',
      text: ''
    }
  },
  computed: {
    title () {
      return this.item ? 'Илгээсэн мессеж' : 'Мессеж илгээх'
    },
    maskPhones () {
      const mask = []
      let str = '####-####'
      for (const i of Array(100).keys()) {
        mask.push(str)
        str += ', ####-####'
      }
      return mask
    },
    phoneCount () {
      if (!this.phones) {
        return 0
      }
      return this.phones.split(',').length
    },
    visibleModel: {
      get () {
        return this.visible
      },
      set (val) {
        this.$emit('update:visible', val)
      }
    }
  },
  watch: {
    visible (val) {
      if (val) {
        this.setItem()
      }
    }
  },
  created () {
    this.setItem()
  },
  methods: {
    setItem () {
      if (this.item) {
        this.phones = this.item.phone
        this.text = this.item.text
      }
    },
    async sendSms () {
      try {
        const phoneArray = this.phones.split(', ')
        for (const item of phoneArray) {
          if (item && !regexpMobile.test(item)) {
            this.customError('Буруу утасны дугаар агуулагдсан байна.')
          }
        }
        if (!this.text) {
          this.customError('Утга оруулна уу.')
        }
        if (!regexpSmsText.test(this.text)) {
          this.customError('Буруу утга агуулагдсан байна.')
        }
        await this.showConfirm({ message: 'Та мессеж илгээх үү?' })
        this.loading = true
        await this.axios.post('contracts/sms', {
          phones: this.phones,
          text: this.text
        })
        this.showToast('Амжилттай илгээж дууслаа.')
        this.visibleModel = false
        this.$emit('save-success')
      } catch (err) {
        this.handleError(err)
      } finally {
        this.loading = false
      }
    }
  }
}
</script>
